<template>
  <div :data-theme="theme">
    <div
      class="sticky top-0 z-30 flex h-16 w-full justify-center bg-opacity-90 backdrop-blur transition-all duration-100 bg-base-100 text-base-content"
    >
      <div class="navbar">
        <div class="navbar-start">
          <a class="btn btn-ghost normal-case text-xl">Rodrigo Fernández</a>
        </div>
        <div class="navbar-center hidden lg:flex"></div>
        <div class="navbar-end">
          <ul class="menu menu-horizontal px-1 hidden lg:flex">
            <li>
              <a href="#home" @click.prevent="scrollToSection('#home')"
                >Inicio</a
              >
            </li>
            <li>
              <a href="#about" @click.prevent="scrollToSection('#about')"
                >Acerca de</a
              >
            </li>
            <li>
              <a
                href="#employment"
                @click.prevent="scrollToSection('#employment')"
                >Historial Laboral</a
              >
            </li>
            <li>
              <a href="#skills" @click.prevent="scrollToSection('#skills')"
                >Habilidades</a
              >
            </li>
            <li>
              <a href="#projects" @click.prevent="scrollToSection('#projects')"
                >Proyectos</a
              >
            </li>
          </ul>
          <div class="dropdown dropdown-end sm:hidden">
            <button class="btn btn-square btn-ghost" @click="isOpen">
              <svg
                class="swap-off fill-current"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 512 512"
              >
                <path
                  d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z"
                />
              </svg>
            </button>
            <ul
              tabindex="0"
              class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
              :class="menuOpen ? ' ' : 'hidden'"
            >
              <li>
                <a href="#home" @click.prevent="scrollToSection('#home')"
                  >Inicio</a
                >
              </li>
              <li>
                <a href="#about" @click.prevent="scrollToSection('#about')"
                  >Acerca de</a
                >
              </li>
              <li>
                <a
                  href="#employment"
                  @click.prevent="scrollToSection('#employment')"
                  >Historial Laboral</a
                >
              </li>
              <li>
                <a href="#skills" @click.prevent="scrollToSection('#skills')"
                  >Habilidades</a
                >
              </li>
              <li>
                <a
                  href="#projects"
                  @click.prevent="scrollToSection('#projects')"
                  >Proyectos</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <HomeView id="home" />
    <AboutView id="about" />
    <EmploymentView id="employment" />
    <SkillView id="skills" />
    <ProjectView id="projects" />
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { ref, onMounted, computed } from "vue";

import AboutView from "@/views/AboutView.vue";
import SkillView from "@/views/SkillView.vue";
import ProjectView from "@/views/ProjectView.vue";
import HomeView from "@/views/HomeView.vue";
import EmploymentView from "@/views/EmploymentView.vue";

const store = useStore();
var menuOpen = ref(false);
const theme = computed(() => store.getters.getTheme);

/* const toggle = () => {
  this.$refs.inputDrawer.checked = !this.$refs.inputDrawer.checked;
}; */

const isOpen = () => {
  menuOpen.value = !menuOpen.value;
};

const scrollToSection = (selector) => {
  const section = document.querySelector(selector);
  section.scrollIntoView({
    behavior: "smooth",
  });
};

onMounted(() => {
  store.dispatch("setTheme", theme.value);
});
</script>

<style></style>
